import { calculateManagementControlScore, calculateRiskRating } from '../lib/scoring'

interface Props {
  formData: Record<string, any>
}

export default function RiskSummary({ formData }: Props) {
  const score = calculateManagementControlScore(formData)
  const rating = calculateRiskRating(score, 'management_control')

  const getRatingColor = (rating: string) => {
    switch (rating) {
      case 'Low':
        return 'bg-success-500'
      case 'Medium':
        return 'bg-warning-500'
      case 'High':
        return 'bg-danger-500'
      default:
        return 'bg-gray-500'
    }
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-xl font-bold mb-4">Risk Summary</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-600 mb-1">Overall Score</div>
          <div className="text-3xl font-bold text-gray-900">{score.toFixed(1)}</div>
        </div>

        <div className={`${getRatingColor(rating)} text-white p-4 rounded-lg`}>
          <div className="text-sm mb-1">Risk Rating</div>
          <div className="text-3xl font-bold">{rating}</div>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
          <div className="text-sm text-gray-600 mb-1">Status</div>
          <div className="text-lg font-semibold text-gray-900">Draft</div>
        </div>
      </div>
    </div>
  )
}
